import React from 'react';
import { Icon } from 'venn-ui-kit';
import { Button } from '@/components/ui/button';
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogTitle } from '@/components/ui/dialog';

interface ApplyAdvisoryFeesConfirmationModalProps {
  onApply: () => void;
  onClose: () => void;
}

export const ApplyAdvisoryFeesConfirmationModal = ({ onApply, onClose }: ApplyAdvisoryFeesConfirmationModalProps) => (
  <Dialog open onOpenChange={(open) => !open && onClose()}>
    <DialogContent
      showCloseButton={false}
      className="w-[550px] [&]:sm:max-w-[550px] p-0 gap-0 rounded-none border-none shadow-[0px_6px_6px_0px_rgba(16,22,27,0.2)] !animate-none"
    >
      <DialogClose className="text-black ring-offset-background focus-visible:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground absolute top-[20px] right-[24px] rounded-xs opacity-70 transition-opacity hover:opacity-100 focus-visible:ring-2 focus-visible:ring-offset-2 focus:outline-hidden disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-9">
        <Icon type="xmark" prefix="fal" className="text-[32px]" />
        <span className="sr-only">Close</span>
      </DialogClose>
      <div className="px-6 py-4 border-0 border-b border-solid border-venn-grey-30">
        <DialogTitle className="m-0 text-[32px] font-light leading-tight">Apply Advisory Fee settings</DialogTitle>
      </div>
      <div className="px-6 py-3">
        <DialogDescription asChild className="text-[14px] text-black">
          <div>
            <p>All new reports in this workspace will have the Advisory Fee limits applied.</p>
            <p className="mt-3">
              Previously-saved reports that include fees outside of these limits will need to be updated before they can
              be saved or exported.
            </p>
          </div>
        </DialogDescription>
      </div>
      <div className="px-6 py-3 flex justify-between items-center border-0 border-t border-solid border-venn-grey-30">
        <Button variant="outline" size="xl" onClick={onClose}>
          Cancel
        </Button>
        <Button
          onClick={onApply}
          className="h-[40px] px-[15px] py-[10px] uppercase text-[11px] font-bold tracking-[1px] leading-none bg-venn-dark-blue hover:bg-venn-dark-blue/90"
        >
          Apply
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);
